import { Modal, Space } from "antd";

import React from "react";

const FullMessagePopup = ({ closePopup, item }) => {
  return (
    <>
      <Modal
        title="Message"
        open={true}
        width={768}
        onOk={() => closePopup()}
        onCancel={() => closePopup()}
      >
        <Space direction="vertical">
          <div>
            <strong>From</strong>
            <p>
              {`${item.name}${item.email ? ` (${item.email})` : ""}${
                item.phone ? ` (${item.phone})` : ""
              }`}
            </p>
          </div>
          <div>
            <strong>Subject</strong>
            <p>{item.subject}</p>
          </div>
          <div>
            <strong>Message</strong>
            <p>{item.message}</p>
          </div>
        </Space>
      </Modal>
    </>
  );
};

export default FullMessagePopup;
